import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import ReactDomClient from 'react-dom/client'
import request from '../../../utils/request'
import Button from '../../../baseComponent/button'
import Icon from '../../icon'
import Modal from '../../modal'
import styles from './index.module.less'

export default (props) => {
  const div = props?.root || document.createElement('div')
  return new Promise(() => {
    if (ReactDOM?.render) {
      ReactDOM?.render(<NotVisitedRecently {...props} visible container={div} />, div)
    } else if (ReactDomClient.createRoot) {
      const root = ReactDomClient.createRoot(div)
      root.render(<NotVisitedRecently {...props} visible container={div} />)
    }
  })
}

const NotVisitedRecently = ({ data = {}, inspirationIdList = [], onCancel, container }) => {
  const [_visible, set_Visible] = useState(false)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    const result = await request.get('/zhikuan/mn/propagate/last-week-user-used', { params: { inspirationId: data.id } })
    if (result) {
      set_Visible(result)
    }
  }

  const _cancel = () => {
    onCancel && onCancel()
    set_Visible(false)
  }

  const link = data.parentId && data.parentId !== -1
    ? `/meinian/home/coll/detail/${data.id}?tab=1&inspirationId=${data.id}&parentId=${data.parentId}&name=${data.name}&trackSourceType=采集时跳转`
    : `/meinian/home/coll/detail/${data.id}?inspirationId=${data.id}&trackSourceType=采集时跳转`

  return <Modal
    container={container}
    style={{ width: '480px' }}
    visible={_visible}
    onClose={_cancel}
    hiddenFooter
    onVisibleChange={val => set_Visible(val)}
  >
    <div className={styles.notVisitedRecently}>
      <img className="notVisitedRecentlyImage" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/collect-notification/jinqiweifangwen.png" />
      <div className="notVisitedRecentlyImageLine1">
        灵感集内推荐款式已生成，快去美念看看吧<Icon type="m-jiantou_you" className="notVisitedRecentlyImageLine1Icon" />
      </div>
      <div className="notVisitedRecentlyImageLine2">
        根据灵感集内采集的内容偏向生成推荐内容
      </div>
      <div style={{ textAlign: 'center' }}>
        <Button
          type="primary"
          className="notVisitedRecentlyImageLine3"
          onClick={() => {
            if (inspirationIdList?.length > 1) {
              window.open('/meinian/home/coll')
            } else {
              window.open(link)
            }
          }}
        >
          立即查看<Icon type="m-jiantou_you" className="notVisitedRecentlyImageLine3Icon" />
        </Button>
      </div>
    </div>
  </Modal>
}
